type Props = { name: string; summary: string; className?: string };

/** A compact exercise row shared by the overview and routine session pages. */
export function ExercisePerformance({ name, summary, className = '' }: Props) {
  return <div className={`exercise-performance ${className}`}><strong>{name}</strong><span>{summary}</span></div>;
}
